import React, { useCallback, useEffect } from "react";
import "./AdminNavBare.css";
import logo from "../../../assets/Images/Logo.png";
import logoDark from "../../../assets/Images/logo-1.png"
import { NavLink, Link, useLocation } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import TimerIcon from "@mui/icons-material/Timer";
import BarChartIcon from "@mui/icons-material/BarChart";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import RoomIcon from "@mui/icons-material/Room";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import { FaRegBell } from "react-icons/fa";
import { useState } from "react";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import { AiOutlineAudit } from "react-icons/ai";
import QuizIcon from "@mui/icons-material/Quiz";

import Avatar from "../../../assets/Images/user-avatar.jpg";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getNotificationsPath } from "../../../services/config";
import { HasHeaderPermission } from "../../../services/hasHeaderPermission";
import {
  commonNotification,
  initNotification,
} from "../../../redux/slices/commonSlice";

const AdminNavBare = () => {
  const themeState = useSelector((state) => state.theme)

  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const userPermissions = JSON.parse(localStorage.getItem("userPermissions")) || []

  const [accessModules, setAccessModules] = useState([]);
  useEffect(() => {
    const splitArray = user.accessModules.split(",");
    setAccessModules(splitArray);
  }, []);

  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);

  const [notifications, setNotification] = useState(0);
  const getNotification = useCallback(() => {
    const path = `${getNotificationsPath}${user.user_id}`;
    dispatch(commonNotification(path));
  }, []);
  useEffect(() => {
    getNotification();
  }, []);

  useEffect(() => {
    if (commonStore.commonNotificationSuccess) {
      setNotification(
        commonStore.commonNotificationData?.pendingApprovalsCount
      );
      dispatch(initNotification());
    }
    if (commonStore.commonNotificationError) {
      dispatch(initNotification());
    }
  }, [
    commonStore.commonNotificationSuccess,
    commonStore.commonNotificationError,
  ]);

  const slider = [
    {
      path: "/dashboard",
      name: "Dashboard ",
      icon: <PersonIcon />,
      isAccess: accessModules.includes("1"),
      hasPermission: HasHeaderPermission("Dashboard", "view"),
    },
    {
      path: "/empmanagement#0",
      name: "Employee ",
      icon: <PersonIcon />,
      isAccess: accessModules.includes("1"),
      hasPermission: HasHeaderPermission("Employee", "view"),
    },
    {
      path: "/attendance#live",
      name: "Attendance ",
      icon: <TimerIcon />,
      isDropdown: false,
      chi: [
        { path: "live-attendance", name: "Live Attendance" },
        { path: "daily-attendance", name: "Daily Attendance" },
        { path: "attendance-dashboard", name: "Attendance Dashboard" },
        { path: "monthly-attendance", name: "Monthly Attendance" },
      ],
      isAccess: accessModules.includes("2"),
      hasPermission: HasHeaderPermission("Attendance", "view"),
    },
    {
      path: "/payroll#payroll-configurations",
      name: "Payroll",
      icon: <ExitToAppIcon />,
      isAccess: accessModules.includes("3"),
      hasPermission: HasHeaderPermission("Payroll", "view"),
    },
    {
      path: "/tracking",
      name: "Tracking",
      icon: <RoomIcon />,
      isAccess: accessModules.includes("7"),
      hasPermission: HasHeaderPermission("Tracking", "view"),
    },
    {
      path: "/performance-management",
      name: "Performance",
      icon: <MonitorHeartIcon />,
      isAccess: accessModules.includes("4"),
      hasPermission: HasHeaderPermission("Performance", "view"),
    },
    {
      path: "/raining-list",
      name: "Training & Development",
      icon: <CastForEducationIcon />,
      isAccess: accessModules.includes("5"),
      hasPermission: HasHeaderPermission("Training & Development", "view"),
    },
    {
      path: "/audit",
      name: "Audit",
      icon: <QuizIcon />,
      isAccess: accessModules.includes("6"),
      hasPermission: HasHeaderPermission("Audit", "view"),
    },
    {
      path: "/reports",
      name: "Reports",
      icon: <BarChartIcon />,
      isAccess: accessModules.includes("6"),
      hasPermission: HasHeaderPermission("Reports", "view"),
    },
  ];

  const navigateDashboard = () => {
    document.getElementById("dash").click();
  };

  const getActiveURL = useCallback(() => {
    const regex = /^\/attendance-settings-holiday\/\d+$/;
    const levRegex = /^\/leave-attendance\/\d+$/;

    return location.pathname == "/company-details" ||
      location.pathname == "/company_branches" ||
      location.pathname == "/company-departments" ||
      location.pathname == "/company-designation" ||
      location.pathname == "/company-roles" ||
      location.pathname == "/my-employee-id" ||
      location.pathname == "/company-reports" ||
      location.pathname == "/attendance-settings-shifts" ||
      location.pathname == "/breaks" ||
      location.pathname == "/holiday-module" ||
      regex.test(location.pathname) ||
      location.pathname == "/leave-module" ||
      levRegex.test(location.pathname) ||
      location.pathname == "/attendance-setting" ||
      location.pathname == "/myteam-admins" ||
      location.pathname == "/employee-manager" ||
      location.pathname == "/employee-manager" ||
      location.pathname == "/current-date-employee-info"
      ? true
      : false;
  }, [location.pathname]);

  const getActivePayrollPath = () => {
    return location.pathname == "/run-payroll" ? true : false
  }

  const getActiveNotificationPath = () => {
    return location.pathname == "/add-announcement" ? true : false
  }

  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const openProfile = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  const [themeName, setThemeName] = useState("")

  const logOut = () => {
    const theme_name = localStorage.getItem("theme")
    setThemeName(theme_name)
    localStorage.removeItem("auth");
    localStorage.removeItem("superadmin");
    localStorage.removeItem("userPermissions");
    localStorage.removeItem("user_data");
    localStorage.removeItem("employee-id");
    if (themeName) {
      localStorage.clear();
      localStorage.setItem("theme", themeName)
    }
    window.location.reload();
  };

  return (
    <>
      {/* <Box
        sx={{
          height: 320,
          transform: "translateZ(0px)",
          flexGrow: 1,
          "& .MuiFab-primary": {
            backgroundColor: "#353636",
            "&:hover": {
              backgroundColor: "#262627",
            },
          },
        }}
        style={{
          position: "fixed",
          bottom: "0",
          right: "10px",
          zIndex: "1600",
        }}
      >
        <SpeedDial
          ariaLabel="SpeedDial controlled open example"
          sx={{ position: "absolute", bottom: 16, right: 16 }}
          icon={<SpeedDialIcon />}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
        >
          {actions.map((action, idx) => (
            <SpeedDialAction
              key={idx}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={() => {
                setOpen(false);
                navigate(action.path);
              }}
            />
          ))}
        </SpeedDial>
      </Box> */}

      <Link to="/dashboard" id="dash" style={{ display: "none" }}></Link>
      <nav className="AdminNavBare" style={{ zIndex: 999 }}>
        <div className="AdminNavBare-left">
          <img
            src={themeState.theme == "dark" ? logo : logoDark}
            alt="logo"
            style={{ cursor: "pointer" }}
            className={themeState.theme == "dark" ? "header_logo_1" : "header_logo"}
            onClick={navigateDashboard}
          />
        </div>

        <div className="AdminNavBare-Right" style={{ overflowX: "auto", zIndex: 999 }}>
          <ul>
            {slider.map((item, i) => {
              const isTrue = userPermissions?.length > 0 ? item.hasPermission : item.isAccess
              return isTrue && <NavLink
                to={item.path}
                className="nav-bar"
                style={{ textDecoration: "none" }}
                key={i}
              >
                {({ isActive }) => (
                  <>
                    <label
                      className={
                        (isActive && item.name != "notification") || (item.name == "Payroll" && getActivePayrollPath())
                          ? "nav_link active"
                          : "nav_link"
                      }
                      key={i}
                    >
                      {/* {item.icon} */}
                      {item.name != "notification" ? item.name : null}
                    </label>

                    {item.isDropdown && (
                      <ul className="SubMenu" id={"dp" + i}>
                        {item.chi.map((r, id) => {
                          return (
                            <li key={id}>
                              <NavLink to={r.path}> {r.name}</NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </>
                )}
              </NavLink>
              // userPermissions.length > 0 ? item.hasPermission : item.isAccess ? (

              // ) : null;
            })}
          </ul>
        </div>
        {/* Profile menu */}
        <div className="profile-menus" style={{ zIndex: 9999 }}>
          {HasHeaderPermission("Notifications", "view") && (
            <NavLink
              to="/notification"
              className={({ isActive }) =>
                isActive || getActiveNotificationPath() ? "setting-link active" : "setting-link"
              }
            >
              <span className="info-notification">
                {notifications
                  ? notifications > 99
                    ? "99+"
                    : notifications
                  : 0}
              </span>
              <FaRegBell className="icon" />
            </NavLink>
          )}

          {HasHeaderPermission("Settings", "view") && (
            <NavLink
              to="/setting"
              className={({ isActive }) =>
                isActive || getActiveURL()
                  ? "setting-link active"
                  : "setting-link"
              }
            >
              <SettingsIcon className="icon" />
            </NavLink>
          )}

          <ul className="list-unstyled">
            <li className="dropdown__ ml-2">
              <a className=" " href="#" role="button"
                data-toggle="dropdown__" aria-haspopup="true" aria-expanded="false">
                <div className="avatar avatar-md avatar-indicators avatar-online">
                  <img alt="avatar" src={user.company_logo ? user.company_logo : Avatar} className="rounded-circle" />
                </div>
              </a>

              <div className="dropdown__-menu">
                <ul className="list-unstyled">
                  <li onClick={logOut} className="dpdn-item">Logout</li>
                </ul>

              </div>
            </li>
          </ul>

          {/* <div className="profile-menu" onClick={openProfile}>
          <Link to="#">
            <img src={Avatar} className="user-profile" />
          </Link>

          <ul
            className={
              isProfileOpen ? `profile-dropdown` : `profile-dropdown`
            }
          >
            <li onClick={logOut} className="dpdn-item">Logout</li>
          </ul>
        </div> */}
        </div>
      </nav >
    </>
  );
};

export default AdminNavBare;
